class MediaGridZoomModal extends CustomDialog {
  constructor() {
    super();
    this.image = this.querySelector('[data-zoom-modal-image]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.media-grid__zoom-button')) {
        this.handleZoomButtonClick(e);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.elements.dialog.open) {
        this.closeDialog();
      }
    });
  }

  handleZoomButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const button = e.target.closest('.media-grid__zoom-button');
    const imageSrc = button.dataset.zoomImage;
    const imageAlt = button.dataset.zoomAlt;
    
    if (imageSrc) {
      this.image.src = imageSrc;
      this.image.alt = imageAlt;
      this.openDialog();
    }
  }

  openDialog() {
    super.openDialog();
    document.body.style.overflow = 'hidden';
  }

  closeDialog() {
    super.closeDialog();
    document.body.style.overflow = '';
  }
}

customElements.define('media-grid-zoom-modal', MediaGridZoomModal); 